import React from 'react'
import { Card } from 'react-bootstrap'
import ModuleDisplayRichText from '../../../../UI/modules/fieldsDisplay/ModuleDisplayRichText'

export default function PollData({ poll }) {
    return (
        <Card className="item  mb-2">
            <Card.Header className="ps-1 pe-2 py-0">
                <Card.Title className="m-0 p-0 ">
                    <div className="d-flex ImageSectionSpacing">

                        <div className="ms-1 me-2 d-flex align-items-center justify-content-center">
                            <i className="fas fa-poll fs-2 me-1 text-secondary position-relative"></i>
                        </div>

                        <div className="d-flex flex-column ms-0">
                            <span className="text-bold memberName p-0 m-0">
                                {poll.title}
                            </span>
                            <span className="font-italic font-small font-weight-normal text-success fs-8  mt-1">
                                <span className="membershipId ">
                                    Total Questions: {poll.questions.length}
                                </span>
                            </span>
                        </div>
                    </div>
                </Card.Title>
            </Card.Header>
            {poll.description && (
                <Card.Body>

                    <ModuleDisplayRichText value={poll.description} />

                </Card.Body>
            )}
        </Card>
    )
}
